module.exports = __webpack_public_path__ + "img/Dashboard_cards.0fe39ff5.webp";